export default __webpack_public_path__ + "static/media/girloncarpet.57d1642b.jpg";